import { Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import Iseria from 'assets/images/png/home/iseria.png'
import Soraya from 'assets/images/png/home/soraya.png'
import XingTian from 'assets/images/png/home/xingtian.png'
import VideoBg from 'assets/images/png/home/mid-gard-video-bg.png'
// import KnightIcon from 'assets/images/svg/home/knight.svg'
import PlayIcon from 'assets/images/png/common/play.png'
import PauseIcon from 'assets/images/png/common/pause.png'
import LinkIcon from 'assets/images/svg/common/link.svg'
import StarIcon from 'assets/images/svg/common/star.svg'
import ActiveLinkIcon from 'assets/images/svg/common/active-link.svg'
import MidgardLogo from 'assets/images/svg/home/mid-gard-logo.svg'
import { animated, useSpring } from '@react-spring/web'
import { useInView } from 'react-intersection-observer'
import ReactPlayer from 'react-player'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useHomePlayId } from 'state/application/hooks'
import { useAppDispatch } from 'state/hooks'
import { setHomePlayId } from 'state/application/reducer'

const Wrapper = styled(Box)`
  padding-top: 83px;
  position: relative;
  height: 827px;
  @media (max-width: 1200px) {
    padding-top: 83px;
    height: 827px;
  }
  @media (max-width: 900px) {
    height: unset;
    margin-top: 80px;
    padding-top: 50px;
  }
`

const Content = styled(Box)`
  position: absolute;
  width: 100vw;
  left: 0;
  top: -83px;
  .mid-gard {
    z-index: 1;
  }
  @media (max-width: 900px) {
    position: relative;
    width: 100%;
  }
`

const BgBox = styled(Box)`
  background: linear-gradient(180deg, #ea6b24 0%, #350804 100%);
  opacity: 0.2;
  width: 100%;
  height: 360px;
  margin-top: 95px;
  @media (max-width: 900px) {
    height: 51.466vw !important;
    margin-top: 0;
    position: absolute;
    top: 17px;
    left: 0;
  }
  @media (max-width: 1200px) {
    height: 270px;
  }
`
const VideoMaskBox = styled(Box)`
  width: 640px;
  height: 360px;
  margin-top: 261px;
  margin-bottom: 20px;
  @media (max-width: 1200px) {
    width: 480px;
    height: 270px;
    margin-top: 260px;
  }
  @media (max-width: 900px) {
    width: 100% !important;
    height: 51.466vw;
    margin-top: 50px;
  }
`
const VideoBox = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 200ms;
  background-position: center;
  background-size: 100%;
  .pause-icon {
    display: none;
    transform: all 200ms;
  }
  video {
    transition: all 200;
  }
  ::after {
    position: absolute;
    content: '';
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    opacity: 0.4;
    width: 2px;
    height: 480px;
    right: -17px;
    top: 180px;
    transition: top 200ms, opacity 200ms;
  }
  .MuiBox-root {
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: 100%;
    transition: all 200ms;
    padding-left: 32px;
    padding-top: 180px;
    :hover {
      background-image: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
      .pause-icon {
        display: block;
      }
    }
    .MuiTypography-root {
      opacity: 0;
      transition: opacity 200ms;
    }
  }
  :hover {
    video: {
      transform: scale(1.1);
    }
    .MuiTypography-root {
      opacity: 1;
    }
    ::after {
      top: 0;
      opacity: 0;
    }
  }
  @media (max-width: 1200px) {
    ::after {
      position: absolute;
    }
    .MuiBox-root {
    }
  }
  @media (max-width: 900px) {
    ::after {
      display: none;
    }
    .MuiBox-root {
      padding-top: 280px;
    }
    img {
      width: 46px;
    }
    .MuiTypography-h3 {
      font-size: 24px !important;
    }
  }
  @media (max-width: 600px) {
    .MuiBox-root {
      padding-top: 130px;
    }
  }
`

const RightBox = styled(Box)`
  margin-left: 0;
  width: 735px;
  padding-right: 95px;
  background: url(${VideoBg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position-y: 40%;
  .mid-gard-logo {
    float: right;
    margin-top: 200px;
  }
  @media (max-width: 1200px) {
    width: 480px;
    padding-right: 0;
    .mid-gard-logo {
      float: right;
      margin-top: 190px;
    }
  }
  @media (max-width: 900px) {
    width: 100%;
    padding: 0;
    background-size: 120%;
    background-position-y: -6%;
    background-position-x: -24px;

    .MuiTypography-body2 {
      padding: 0 16px;
    }
    .mid-gard-logo {
      float: left;
      width: 48.666%;
      margin-top: -30px;
      margin-left: 16px;
    }
    > p {
      font-weight: 400;
      color: #ffffff;
    }
  }
  @media (max-width: 600px) {
    .mid-gard-logo {
      margin-top: unset;
    }
  }
`
const MintBox = styled(Box)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-top: 20px;
  z-index: 9;
  .MuiTypography-root {
    margin-right: 16px;
  }
  .link-box {
    width: 40px;
    height: 40px;
    background-size: contain;
    background-repeat: no-repeat;
    background: url(${LinkIcon});
    transition: all 200ms;
  }
  @media (max-width: 1200px) {
    .link-box {
      width: 4rem;
      height: 4rem;
      background-size: contain;
    }
  }
  :hover {
    .link-box {
      margin-left: 4px;
      background-size: contain !important;
      background: url(${ActiveLinkIcon});
    }
  }
  @media (max-width: 900px) {
    padding: 0 16px;
    .MuiTypography-root {
      margin-right: 16px;
      font-weight: 600;
      font-size: 24px;

      color: #ffffff;
    }
    .link-box {
      width: 24px;
      height: 24px;
      background-size: cover;
    }
  }
`
const LeftBox = styled(Box)`
  position: relative;
  width: 600px;
  overflow: hidden;
  img {
    position: absolute;
  }
  img:first-of-type {
    z-index: 2;
    width: 415px;
  }
  img:last-child {
    z-index: 1;
    width: 382px;
  }
  img:nth-of-type(2) {
    z-index: 3;
    width: 493px;
  }
  @media (max-width: 1200px) {
    width: 500px;
    img:first-of-type {
      width: 332px;
    }
    img:last-child {
      z-index: 1;
      width: 305.6px;
    }
    img:nth-of-type(2) {
      z-index: 3;
      width: 394px;
    }
  }
  @media (max-width: 900px) {
    width: 100%;
  }
`

const LinearBox = styled(Box)`
  background: linear-gradient(180deg, #121212 0%, #000000 100%);
  width: 100%;
  height: calc(100% - 360px);
  @media (max-width: 900px) {
    display: none;
  }
`

export function MidGard({
  id,
  videoUrl,
  poster,
  showVideo,
}: {
  id: string
  videoUrl: string
  poster: string
  showVideo: boolean
}) {
  const theme = useTheme()
  const lg = useMediaQuery(theme.breakpoints.down('lg'))
  const navigate = useNavigate()
  const playId = useHomePlayId()
  const dispatch = useAppDispatch()
  const playing = useMemo(() => {
    return playId === id
  }, [playId, id])

  const { ref, inView } = useInView({
    threshold: 0,
    delay: 300,
    rootMargin: '60px 0px 0px 60px',
  })
  const SorayaStyles = useSpring({
    opacity: inView ? 1 : 0,
    right: inView ? (lg ? '95' : '112px') : '512px',
    top: inView ? (lg ? '242px' : '240px') : '240px',
  })
  const IseriaStyles = useSpring({
    opacity: inView ? 1 : 0,
    right: inView ? (lg ? '-55px' : '-60px') : '460px',
    top: inView ? (lg ? '265px' : '265px') : '265px',
  })
  const XingTianStyles = useSpring({
    opacity: inView ? 1 : 0,
    right: inView ? (lg ? '-15px' : '-25px') : '475px',
    top: inView ? (lg ? '150px' : '125px') : '125px',
  })
  return (
    <>
      <Wrapper ref={ref}>
        <BgBox></BgBox>
        <LinearBox></LinearBox>
        <Content>
          <Box display="flex" justifyContent="center">
            <LeftBox className="smShowNo">
              <animated.img style={SorayaStyles} src={Soraya} alt="" />
              <animated.img style={IseriaStyles} src={Iseria} alt="" />
              <animated.img style={XingTianStyles} src={XingTian} alt="" />
            </LeftBox>
            <RightBox>
              <img src={MidgardLogo} alt="" className="mid-gard-logo"></img>
              <VideoMaskBox>
                <VideoBox>
                  <ReactPlayer
                    width="100%"
                    height="100%"
                    config={{
                      file: {
                        attributes: {
                          poster,
                        },
                      },
                    }}
                    style={{
                      visibility: showVideo ? 'hidden' : 'unset',
                    }}
                    muted
                    playing={playing}
                    url={videoUrl}
                  />
                  <Box display="flex" alignItems="center">
                    <img
                      src={playing ? PauseIcon : PlayIcon}
                      className={playing ? 'pause-icon' : ''}
                      alt=""
                      onClick={() => {
                        if (playId === id) {
                          dispatch(setHomePlayId(''))
                        } else {
                          dispatch(setHomePlayId(id))
                        }
                      }}
                    ></img>
                    <Typography variant="h3" color={theme.colors.white}>
                      {playing ? 'Pause Video' : 'Watch Video'}
                    </Typography>
                  </Box>
                </VideoBox>
              </VideoMaskBox>
              <Typography variant="body2" color={theme.colors.white}>
                <em>Midgard Saga</em> is a casual idle RPG. Its strategy-focused gameplay and exquisite battle scenes
                provide an immersive and relaxing experience for players who wish to roleplay as a prince looking to
                save his kingdom.
              </Typography>
              <Box display="flex" flexDirection="column">
                <MintBox
                  onClick={() => {
                    navigate(`/game/${id}`)
                  }}
                >
                  <Typography variant="h3" color={theme.colors.white}>
                    Learn More
                  </Typography>
                  <Box className="link-box"></Box>
                </MintBox>
                <MintBox
                  onClick={() => {
                    navigate('/mint/midgardsaga')
                  }}
                >
                  <Typography variant="h3" color={theme.colors.white}>
                    NFT Mint
                    <img src={StarIcon} alt=""></img>
                  </Typography>
                  <Box className="link-box"></Box>
                </MintBox>
              </Box>
            </RightBox>
          </Box>
        </Content>
      </Wrapper>
    </>
  )
}
